import React, { useState } from "react";
import { useAppSelector, useAppTranslation } from "@/utils";
import { Button, Drawer, Flex, LegacyForm, Input, Typography } from "@payping/web-components";
import { Close } from "@payping/icons";
import EditActionButtons from "@/components/mobile/settings/EditActionButtons";
import { ValidLocalPhoneNumber } from "@payping/utils/validation";
import { DashboardRoutes } from "@/router/constant";
import { useIsLocalDisabled } from "@/mobile/Settings/Business/Edit/utils/useIsLocalDisabled";
import { useHandleNavigationURL, useSaveToRedux } from "@/mobile/Settings/Business/utils";
import { settingsBusinessAtom } from "../../state";
import { selectAtom } from "jotai/utils";
import { useAtom } from "jotai";

const mobileFormEditAtom = selectAtom(settingsBusinessAtom, (val) => val.mobileFormEdit);

const MobileEditBusinessPhone: React.FC = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(true);

  const { t } = useAppTranslation();
  const [form] = LegacyForm.useForm();
  const isLocalDisabled = useIsLocalDisabled();
  const [mobileFormEditState] = useAtom(mobileFormEditAtom);

  const localPhoneApi = useAppSelector((state) => state.user.localInfo?.localPhone);

  // Custom Hooks
  const { saveToRedux } = useSaveToRedux();
  const { handleNavigationURL } = useHandleNavigationURL();

  return (
    <>
      <Drawer
        open={isDrawerOpen}
        placement={"bottom"}
        height={"100%"}
        title={`${t("edit")} / ${t("localPhone")}`}
        closeIcon={false}
        extra={<Button type={"text"} icon={<Close width={14} height={14} />} onClick={handleNavigationURL} />}
      >
        <Flex vertical>
          <LegacyForm
            onFinish={({ localPhone }) =>
              saveToRedux({
                nextUrlForMobileRegisterURL: DashboardRoutes.register.mEditBusiness.postalCode.url,
                fieldName: "localPhone",
                fieldValue: localPhone,
                setIsDrawerOpen,
              })
            }
            form={form}
            initialValues={{ localPhone: mobileFormEditState.localPhone ?? localPhoneApi }}
          >
            <LegacyForm.Item
              label={t("localPhone")}
              name="localPhone"
              rules={[
                {
                  validator(_, value): Promise<void> {
                    if (value) {
                      if (ValidLocalPhoneNumber(value)) {
                        return Promise.resolve();
                      }
                      return Promise.reject(new Error(t("error.phone")));
                    }
                    return Promise.resolve();
                  },
                },
                { required: true },
              ]}
            >
              <Input
                /** `disabled` prop was commented on a previous commit, but now it doesn't make sense so the prop is returned
                 * if this needs to be removed again please comment the reason */
                disabled={isLocalDisabled}
                maxLength={11}
                placeholder={t("settings.business.placeholders.localPhone")}
              />
            </LegacyForm.Item>
          </LegacyForm>
          <Typography.Text type={"secondary"}>
            {t("settings.business.instructions.postalCodeAndHomePhoneNumber")}
          </Typography.Text>
        </Flex>
      </Drawer>
      <EditActionButtons onAccept={form.submit} />
    </>
  );
};

export default MobileEditBusinessPhone;
